import { Typography } from '@mui/material';
import { connect, type ConnectedProps } from 'react-redux';
import { deleteEvent } from '@/slices/events';
import { type ModalContentProps } from '../../../state';
import { ModalLayout } from '../../layouts';

type Props = ModalContentProps & ConnectedProps<typeof connector>;

const DeleteEventModal = ({
  closeModal,
  modalData: { page, propertyId, eventId },
  deleteEvent,
}: Props) => {
  const handleAccept = () => {
    deleteEvent({ page, propertyId, eventId });
    closeModal();
  };

  return (
    <ModalLayout
      closeModal={closeModal}
      title="Delete Event"
      onAccept={handleAccept}
      acceptText="Delete"
      onCancel={closeModal}
      cancelText="Cancel"
    >
      <Typography>Are you sure you want to delete this event?</Typography>
    </ModalLayout>
  );
};

const connector = connect(null, { deleteEvent });

export default connector(DeleteEventModal);
